import { useEffect, useState } from "react";
import { materialCells } from "@jsonforms/material-renderers";
import { JsonForms } from "@jsonforms/react";
import Header from "../../../../layouts/header/Header";
import Footer from "../../../../layouts/footer/Footer";
import CustomStepperRenderer from "./Renderers/Layout/CustomStepperRenderer";
import { useRouter } from "next/router";
import { getPYPData } from "services";

const customRenderers = [
  {
    tester: (uischema: any) =>
      uischema.options?.variant === "customStepper" ? 10 : -1,
    renderer: CustomStepperRenderer,
  },
];

function BasicDetails() {
  const initialData = {};
  const router = useRouter();
  const [data, setData] = useState(initialData);
  const { uuid } = router.query;
  const [responseData, setResponseData] = useState<any>();
  const [role, setRole] = useState("");
  const [formKey, setFormKey] = useState(0);

  useEffect(() => {
    const fetch = async () => {
      if (!uuid) return;
      try {
        const response: any = await getPYPData(uuid);
        if (response) {
          setResponseData(response);
          setData(response?.json_form_data);
          setRole(response?.user_type);
          setFormKey((prevKey) => prevKey + 1);
        }
      } catch (err) {
        console.log("error", err);
      }
    };
    fetch();
  }, [uuid]);

  const property_uuid = uuid;
  const schema = responseData?.json_form_schema;
  const uischema = responseData?.json_form_ui_schema;

  const updatedData = {
    ...uischema,
    options: {
      ...uischema?.options,
      property_uuid: property_uuid,
      role: role,
    },
  };

  return (
    <>
      <Header />

      <JsonForms
        key={formKey}
        schema={schema}
        uischema={updatedData}
        data={data}
        renderers={customRenderers}
        cells={materialCells}
        validationMode="NoValidation"
        onChange={({ data, errors }) => setData(data)}
      />

      <Footer />
    </>
  );
}

export default BasicDetails;
